import { FC } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import { ViewfinderProps } from "../GalleryUploader/Camera/Camera.types";
import { StyledViewfinder } from "./Styled";

export const Viewfinder: FC<ViewfinderProps> = (props) => {
    return (
        <StyledViewfinder {...props}>
            <PrimaryText className="help-text" textColor="error">
                Вирівняйте телефон, щоб зробити фото
            </PrimaryText>
        </StyledViewfinder>
    );
};
